//The following are re-usable functions that work based on arguments given, generics are used to enhance compatibilty
import { MultiValue} from "react-select";
import {
  FormErrors,
  FormData,
  TouchedFields,
  SelectOption,
} from "../../Components/common/types";

//works for project form and contact form
export function handleBlur<T extends TouchedFields | Partial<TouchedFields>>(
  name: keyof FormData,
  value: string | MultiValue<SelectOption>,
  touched: T,
  setTouched: (touched: T) => void,
  validateFieldWrapper: (
    name: keyof FormData,
    value: string | MultiValue<SelectOption>
  ) => void
) {
  console.log("Touch state handleBlur", touched);
  setTouched({
    ...touched,
    [name]: true,
  });
  // console.log("handleBlur:", name, "value:", value);
  validateFieldWrapper(name, value);
}

//validate field on focus and then blur if left empty
export function validateField<T extends FormErrors | Partial<FormErrors>>(
  name: keyof FormData,
  value: string | MultiValue<SelectOption>, //ensure the mulltivalue type is provided to avoid incompatibilities in wrapper functions
  errors: T,
  setErrors: (errors: T) => void
) {
  // console.log('validateField - name:', name, 'value:', value);
  const newErrors = { ...errors }; //collect all errors and show them at ones

  switch (name) {
    case "name":
      newErrors.name = value ? "" : `${name} is required`;
      break;
    case "email":
      if (typeof value === "string") {
        if (!value) {
          newErrors.email = `${name} is required`;
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          newErrors.email = `${name} address is invalid`;
        } else {
          newErrors.email = "";
        }
      }
      break;
    case "service":
      if (Array.isArray(value)) {
        // console.log("validateField - checking service", value);
        newErrors.service = value.length
          ? ""
          : `at least one ${name} must be selected`;
      }
      break;
    case "message":
      newErrors.message = value ? "" : `${name} is required`;
      break;
    default:
      break;
  }

  setErrors(newErrors);
  // console.log('validateField - errors:', newErrors);
}

//validate on empty submission
export function validate<T extends FormData | Partial<FormData>>(
  formData: T,
  errors: Partial<FormErrors>,
  setErrors: (errors: Partial<FormErrors>) => void,
  setTouched: (touched: TouchedFields) => void
): boolean {
  // console.log('validate - formData:', formData);
  let formIsValid = true;

  (Object.keys(formData) as (keyof FormData)[]).forEach((key) => {
    const value = formData[key];
    if (key === "projectName") return; // Skip validation for projectName
    //a case for undefined or partial value
    if (value !== undefined) {
      validateField(key, value, errors, setErrors);
    }
    // Check if the field is empty or undefined
    if (!value || (key === "service" && formData.service?.length === 0)) {
      formIsValid = false;
      errors[key] = `${
        (key as string).charAt(0).toUpperCase() + (key as string).slice(1)
      } is required`; //a case of empty fields submitted
    }
  });

  setErrors(errors); //a case of empty fields submitted
  // Mark all fields as touched
  setTouched({
    name: true,
    email: true,
    service: true,
    message: true,
  });

  return formIsValid;
}
